"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERRORS = void 0;
exports.ERRORS = {
    // Cart errors
    CART_NOT_MEETS_MOV: {
        errorCode: 'CARTLIB001',
        errorMsg: 'No wholesaler meets the MOV requirements',
    },
    // Voucher errors
    VOUCHER_NOT_FOUND: {
        errorCode: 'VOUCH101',
        errorMsg: 'Voucher not found',
    },
    VOUCHER_CATEGORY_MISSING_WHOLESALERS: {
        errorCode: 'VOUCH102',
        errorMsg: 'Product collection vouchers cannot be used without wholesalers',
    },
    VOUCHER_PRODUCTS_CATEGORY_NOT_MATCH: {
        errorCode: 'VOUCH103',
        errorMsg: 'None of the products in the cart belong to the collection/category associated with the voucher',
    },
    VOUCHER_CATEGORY_NOT_PERCENTAGE: {
        errorCode: 'VOUCH104',
        errorMsg: 'Product category/collection vouchers can only be used with percentage discounts',
    },
    // Generic error
    VALIDATION_ERROR: {
        errorCode: 'CARTLIB999',
        errorMsg: 'Validation Error: %s',
    },
};
